import { FuseNavigationItem } from "@fuse/components/navigation";

export const visitRegisterNavigation: FuseNavigationItem = {
    id: 'visit-register',
    title: 'Registro de Visitas',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/dashboard/visit-register',
};